import { ref } from 'vue';
import Swal from "sweetalert2";
import i18n from "@/i18n/index"

import { useAuthenticatedFetch } from '../auth/useAuthenticatedFetch';
import router from "@/router/index";
import { permissions, userPermissions, clubUUID, userUUID } from '@/shared/state';
import { Permission, PermissionResponse, PermissionRequest, AffectedPermissionRequest } from '@/interfaces/permission';



const { authenticatedFetch } = useAuthenticatedFetch();
const API_URL = process.env.VUE_APP_ROOT_API;
export function usePermission() {
    const error = ref<string | null>(null);
    const isRequestPermission = ref<boolean | false>(false);

    const getUserPermissions = async (body: any) => {
        try {
            isRequestPermission.value = true
            userPermissions.data = []
            const response = await authenticatedFetch(`${API_URL}admin-permissions/${body.userUUID}/${body.clubUUID}`, {
                method: 'GET'
            }, false, '', false);

            if (response?.data) {
                userPermissions.data = response?.data || []
                isRequestPermission.value = false
                return true
            } else {
                isRequestPermission.value = false
                return false
            }
        } catch (err: any) {
            error.value = err.message;
            isRequestPermission.value = false
        }
    };
    const getAllPermissions = async ( ) => {
        try {
            isRequestPermission.value = true
            permissions.data = []
            const response = await authenticatedFetch(`${API_URL}all-permissions`, {
                method: 'GET'
            }, false, '', false);

            if (response?.data) {
                permissions.data = response?.data || []
                isRequestPermission.value = false
                return true
            } else {
                isRequestPermission.value = false
                return false
            }
        } catch (err: any) {
            error.value = err.message;
            isRequestPermission.value = false
        }
    };


    const affectedPermissionsToUser = async (body: AffectedPermissionRequest) => {
        try {
            isRequestPermission.value = true
            const response = await authenticatedFetch(`${API_URL}permissions/affected`, {
                method: 'POST',
                body: JSON.stringify(body),
            }, true, '', false);
            if (response) {
                console.log(response)
                if (response?.data) {
                    isRequestPermission.value = false
                    return true
                }
                isRequestPermission.value = false
                return false
            }
        } catch (err: any) {
            error.value = err.message;
            isRequestPermission.value = false
        }
    };


    const hasPermission = (permissionName) => {
        // Find the permission by name and return its status
        const permission = userPermissions?.data?.find(p => p.name === permissionName);
        return permission ? permission?.status : false;
    }

    return {
        getUserPermissions,
        affectedPermissionsToUser,
        hasPermission,
        isRequestPermission,
        getAllPermissions

    };
}
